import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ref, get, set } from 'firebase/database';
import { realtimeDb } from '../../firebase';
import { FaArrowLeft } from 'react-icons/fa';
import { normalizeCompanyKey, firebaseCompanyKey, isDivisionValid } from '../../Utils/companyUtils';

const ManageDivisionInfo = () => {
  const { division } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const rawCompany = location.state?.company || localStorage.getItem('selectedCompany') || 'Sagar Power Lines';
  const normalizedCompany = normalizeCompanyKey(rawCompany);
  const companyPath = firebaseCompanyKey(normalizedCompany);

  const [address, setAddress] = useState('');
  const [gst, setGst] = useState('');

  useEffect(() => {
    if (!normalizedCompany || !division) {
      console.error('Missing company or division:', { rawCompany, normalizedCompany, division });
      alert('Company or division not specified.');
      return;
    }

    if (!isDivisionValid(normalizedCompany, division)) {
      console.error('Invalid division for company:', { normalizedCompany, division });
      alert(`Division "${division}" is not valid for company "${normalizedCompany}".`);
      navigate(-1);
      return;
    }

    const infoPath = `${companyPath}/${division}/info`;
    console.log('Fetching info from path:', infoPath);
    const infoRef = ref(realtimeDb, infoPath);

    get(infoRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          console.log('Info data:', data);
          setAddress(data.address || '');
          setGst(data.gst || '');
        } else {
          console.warn('No info found at path:', infoPath);
          setAddress('');
          setGst('');
        }
      })
      .catch((error) => {
        console.error('Error fetching info:', error);
        alert(`Failed to load division info: ${error.message}`);
      });
  }, [normalizedCompany, division, companyPath, navigate]);

  const handleSave = async () => {
    if (!normalizedCompany || !division) {
      console.error('Cannot save: Missing company or division:', { normalizedCompany, division });
      alert('Company or division not specified.');
      return;
    }

    if (!isDivisionValid(normalizedCompany, division)) {
      console.error('Invalid division for company:', { normalizedCompany, division });
      alert(`Division "${division}" is not valid for company "${normalizedCompany}".`);
      return;
    }

    const infoPath = `${companyPath}/${division}/info`;
    const infoData = { address: address.trim(), gst: gst.trim() };
    console.log('Saving info to path:', infoPath, infoData);
    const infoRef = ref(realtimeDb, infoPath);

    try {
      await set(infoRef, infoData);
      console.log('Division info saved successfully:', infoData);
      alert('Division info saved successfully.');
      navigate(`/admin/division/${division}`, { state: { company: normalizedCompany } });
    } catch (error) {
      console.error('Error saving info:', error);
      alert(`Failed to save division info: ${error.message}`);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4">
      <div className="flex items-center gap-4 mb-4">
        <FaArrowLeft
          onClick={() => navigate(`/admin/division/${division}`, { state: { company: normalizedCompany } })}
          className="cursor-pointer"
        />
        <h2 className="text-xl font-bold">Manage Division Info – {normalizedCompany} ({division})</h2>
      </div>

      <label className="block mb-2">Address:</label>
      <textarea
        rows={3}
        className="w-full border p-2 mb-4"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
      />

      <label className="block mb-2">GST Number:</label>
      <input
        type="text"
        className="w-full border p-2 mb-6"
        value={gst}
        onChange={(e) => setGst(e.target.value)}
      />

      <button
        onClick={handleSave}
        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
      >
        Save Info
      </button>
    </div>
  );
};

export default ManageDivisionInfo;